var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-y medium-grid-frame",attrs:{"id":"application"}},[_c('SiteHeader',{staticClass:"cell",attrs:{"search-term":_vm.searchTerm,"search-location":_vm.searchLocation},on:{"search":_vm.onSearch}}),_vm._v(" "),_c('router-view',{staticClass:"cell auto"}),_vm._v(" "),_c('SiteFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0405a5e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 495
// module chunks = 0